import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledDivComponent } from '../types';

interface OverlayProps {
  showHeader?: boolean;
}

type OverlayPropsThemed = ThemeProps<Theme> & OverlayProps;

export const Overlay: StyledDivComponent<OverlayProps> = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${(props: OverlayPropsThemed) =>
    props.showHeader ? '950' : '2050'};
  background-color: ${(props: OverlayPropsThemed) =>
    props.theme.colors.secondary};
  background: rgba(1, 52, 96, 0.9);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`;
